<div data-cy="payment-method-details">
  <div *ngIf="paymentMethod.type === PaymentMethodType.CreditCard" class="flex flex-column">
    <ng-container [ngTemplateOutlet]="creditCardDetails" [ngTemplateOutletContext]="{ creditCard: paymentMethod.info }">
    </ng-container>
  </div>
  <div *ngIf="paymentMethod.type === PaymentMethodType.BankAccount" class="flex flex-column">
    <ng-container
      [ngTemplateOutlet]="bankAccountDetails"
      [ngTemplateOutletContext]="{ bankAccount: paymentMethod.info }"
    >
    </ng-container>
  </div>
</div>

<ng-template #creditCardDetails let-creditCard="creditCard">
  <div class="flex align-items-start">
    <div class="credit-card-logo-container mr-3 mt-1">
      <img
        class="w-full h-auto"
        [src]="getLogoUrl(creditCard)"
        alt="Icon"
        [attr.data-cy]="'payment-method-logo' + creditCard.processor"
      />
    </div>
    <div class="flex flex-column">
      <p class="my-0 p3 font-semibold" data-cy="payment-method-title">
        {{ creditCard.processor }}<span class="font-light"> ending in {{ creditCard.number!.slice(-4) }}</span>
      </p>
      <p
        class="mt-1 mb-0 p3 font-light text-black-400"
        [ngClass]="[creditCard.isExpired ? 'text-error-base' : '']"
        data-cy="payment-method-description"
      >
        {{ creditCard.isExpired ? 'expired on' : 'expires on' }}
        {{ creditCard.expirationMonth }}/{{ creditCard.expirationYear }}
      </p>
    </div>
  </div>
</ng-template>

<ng-template #bankAccountDetails let-bankAccount="bankAccount">
  <div class="flex align-items-start">
    <div class="echeck-logo-container mr-3 mt-1">
      <img
        class="w-full h-auto"
        src="./assets/images/echeck-icon.svg"
        alt="Icon"
        [attr.data-cy]="'payment-method-echeck-icon'"
      />
    </div>
    <div class="flex flex-column">
      <p class="my-0 p3 font-semibold" data-cy="payment-method-title">
        {{ bankAccount.accountType | titlecase }} Account
      </p>
      <p class="mt-1 mb-0 p3 font-light text-black-400" data-cy="payment-method-description">
        Bank account ending in {{ bankAccount.accountNumber!.slice(-4) }}
      </p>
    </div>
  </div>
</ng-template>
